/* src/app/page-loader/page-loader.component.scss */
.loader-screen {
  position: fixed;
  inset: 0;
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
}
.loader-container {
  width: 280px;
  padding: 28px 25px 22px;
  text-align: center;
  background: #fff;
  border: 1px solid #eaecf0;
  border-radius: 14px;
  box-shadow: 0 8px 30px rgba(16, 24, 40, 0.07);
  animation: loaderFade 0.3s ease;
}
.loader-orbit {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 76px;
  height: 76px;
  margin: 0 auto 20px;
}
.loader-ring {
  position: absolute;
  inset: 0;
  border: 2px solid #e8ebff;
  border-top-color: #334155;
  border-right-color: #8b72ed;
  border-radius: 50%;
  animation: rotate 1.5s linear infinite;
}
.loader-ring-inner {
  inset: 9px;
  border: 1.5px dashed #c8d0ff;
  animation: rotateReverse 3s linear infinite;
}
.loader-core {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  color: #fff;
  font-size: 20px;
  background:
    linear-gradient(
      135deg,
      #334155,
      #8061df);
  border-radius: 13px;
  box-shadow: 0 4px 12px rgba(82, 108, 229, 0.22);
  animation: pulse 2s ease-in-out infinite;
}
.orbit-dot {
  position: absolute;
  width: 7px;
  height: 7px;
  background: #8061df;
  border: 2px solid #fff;
  border-radius: 50%;
}
.dot-one {
  top: 7px;
  right: 8px;
}
.dot-two {
  bottom: 8px;
  left: 7px;
  background: #334155;
}
.loader-text h6 {
  margin: 0 0 6px;
  color: #101828;
  font-size: 15px;
  font-weight: 600;
}
.loader-text p {
  margin: 0;
  color: #667085;
  font-size: 12px;
  line-height: 1.5;
}
.loader-progress {
  height: 4px;
  margin: 20px 0 14px;
  overflow: hidden;
  background: #eef0ff;
  border-radius: 10px;
}
.loader-progress span {
  display: block;
  width: 35%;
  height: 100%;
  background:
    linear-gradient(
      90deg,
      #334155,
      #9873ed);
  border-radius: inherit;
  animation: progress 1.5s ease-in-out infinite;
}
.loader-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  color: #98a2b3;
  font-size: 11px;
}
.loader-footer i {
  color: #12b76a;
  font-size: 12px;
}
@keyframes rotate {
  to {
    transform: rotate(360deg);
  }
}
@keyframes rotateReverse {
  to {
    transform: rotate(-360deg);
  }
}
@keyframes pulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.07);
  }
}
@keyframes progress {
  0% {
    transform: translateX(-110%);
  }
  100% {
    transform: translateX(310%);
  }
}
@keyframes loaderFade {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@media (prefers-reduced-motion: reduce) {
  .loader-ring,
  .loader-core,
  .loader-progress span {
    animation: none;
  }
}
/*# sourceMappingURL=page-loader.component.css.map */
